type VerifiedIconProps = {
  color?: string;
  size?: string;
};

export const VerifiedIcon = ({
  color = "#12703D",
  size = "14",
}: VerifiedIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#zbrzidyxva)">
      <g clipPath="url(#5g4ro9y58b)">
        <g clipPath="url(#nqpvnpgifc)">
          <path
            d="M5.908 11.815A5.908 5.908 0 1 1 5.908 0a5.908 5.908 0 0 1 0 11.815zm0-10.707a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zM7.54 3.92a.554.554 0 0 1 .895.651L5.617 8.448a.554.554 0 0 1-.837.067l-1.29-1.29a.554.554 0 0 1 .782-.781l.83.83 2.438-3.35V3.92z"
            fill={color}
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="zbrzidyxva">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
      <clipPath id="5g4ro9y58b">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
      <clipPath id="nqpvnpgifc">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
